<template>
  <div>
    <el-breadcrumb separator-icon="ArrowRight" style="margin: 16px">
      <el-breadcrumb-item :to="{ path: '/home' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>报修申请</el-breadcrumb-item>
    </el-breadcrumb>

    <!-- PC端 -->
    <el-card v-if="!isMobile" style="margin: 15px; min-height: calc(100vh - 111px)">
      <div style="margin: 10px 0">
        <div style="display: flex; align-items: center;">
          <el-input v-model="search" clearable placeholder="请输入标题" prefix-icon="Search" style="width: 200px"/>
          <el-button icon="Search" style="margin-left: 5px" type="primary" @click="load"/>
          <div style="margin-left: auto;">
            <el-button icon="plus" type="primary" @click="add">新增报修</el-button>
          </div>
        </div>
      </div>
      <el-table v-loading="loading" :data="tableData" border max-height="705" style="width: 100%">
        <el-table-column label="#" type="index" width="50"/>
        <el-table-column label="标题" prop="title" min-width="100"/>
        <el-table-column label="宿舍号" prop="dormRoomId" min-width="80"/>
        <el-table-column :filter-method="filterTag" :filters="[{ text: '已处理', value: '已处理' }, { text: '未处理', value: '未处理' }]" filter-placement="bottom-end" label="状态" prop="state" min-width="80">
          <template #default="scope">
            <el-tag :type="scope.row.state === '已处理' ? 'success' : 'info'" disable-transitions>{{ scope.row.state }}</el-tag>
          </template>
        </el-table-column>
        <el-table-column label="订单创建时间" prop="orderBuildTime" min-width="140" sortable/>
        <el-table-column label="操作" width="74px" fixed="right">
          <template #default="scope">
            <el-button icon="more-filled" type="default" @click="showDetail(scope.row)"/>
          </template>
        </el-table-column>
      </el-table>
      <div style="margin: 10px 0">
        <el-pagination v-model:currentPage="currentPage" :page-size="pageSize" :page-sizes="[10, 20]" :total="total" layout="total, sizes, prev, pager, next, jumper" @size-change="handleSizeChange" @current-change="handleCurrentChange"/>
      </div>

      <!-- 新增弹窗 -->
      <el-dialog v-model="dialogVisible" title="新增报修" width="500px" @close="cancel">
        <el-form ref="formRef" :model="form" :rules="rules" label-width="100px">
          <el-form-item label="标题" prop="title">
            <el-input v-model="form.title" clearable placeholder="请输入报修标题"/>
          </el-form-item>
          <el-form-item label="房间信息">
            <el-input :model-value="formatRoomLabel()" disabled/>
          </el-form-item>
          <el-form-item label="申请人">
            <el-input v-model="form.repairer" disabled/>
          </el-form-item>
          <el-form-item label="报修内容" prop="content">
            <el-input v-model="form.content" :autosize="{ minRows: 3, maxRows: 8 }" type="textarea" clearable placeholder="请描述报修问题"/>
          </el-form-item>
        </el-form>
        <template #footer>
          <el-button @click="cancel">取消</el-button>
          <el-button type="primary" @click="save">提交</el-button>
        </template>
      </el-dialog>

      <!-- 详情弹窗 -->
      <el-dialog v-model="detailDialog" title="报修详情" width="500px">
        <el-descriptions :column="1" border>
          <el-descriptions-item label="标题">{{ detail.title }}</el-descriptions-item>
          <el-descriptions-item label="宿舍号">{{ detail.dormRoomId }}</el-descriptions-item>
          <el-descriptions-item label="申请人">{{ detail.repairer }}</el-descriptions-item>
          <el-descriptions-item label="状态">
            <el-tag :type="detail.state === '已处理' ? 'success' : 'info'">{{ detail.state }}</el-tag>
          </el-descriptions-item>
          <el-descriptions-item label="提交时间">{{ detail.orderBuildTime }}</el-descriptions-item>
          <el-descriptions-item label="完成时间">{{ detail.orderFinishTime || '-' }}</el-descriptions-item>
          <el-descriptions-item label="内容">
            <div v-html="detail.content"></div>
          </el-descriptions-item>
        </el-descriptions>
        <template #footer>
          <el-button type="primary" @click="closeDetails">确定</el-button>
        </template>
      </el-dialog>
    </el-card>

    <!-- 手机端 -->
    <div v-else class="mobile-container">
      <!-- 顶部操作栏 -->
      <div class="mobile-top-bar">
        <el-input v-model="search" clearable placeholder="搜索标题" prefix-icon="Search" class="mobile-search"/>
        <el-button icon="Search" type="primary" @click="load"/>
        <el-button icon="plus" type="primary" @click="add"/>
      </div>

      <!-- 报修列表 -->
      <div v-loading="loading" class="mobile-list">
        <div v-if="!loading && tableData.length === 0" class="mobile-empty">暂无报修记录</div>
        <div v-for="(item, idx) in tableData" :key="idx" class="mobile-card" @click="showDetail(item)">
          <div class="mobile-card-header">
            <span class="mobile-card-title">{{ item.title || '无标题' }}</span>
            <el-tag size="small" :type="item.state === '已处理' ? 'success' : 'info'">{{ item.state }}</el-tag>
          </div>
          <div class="mobile-card-body">
            <div class="mobile-card-row">
              <span class="mobile-card-label">宿舍号</span>
              <span class="mobile-card-value">{{ item.dormRoomId || '-' }}</span>
            </div>
            <div class="mobile-card-row">
              <span class="mobile-card-label">提交时间</span>
              <span class="mobile-card-value">{{ item.orderBuildTime || '-' }}</span>
            </div>
          </div>
        </div>
      </div>

      <!-- 手机端分页 -->
      <div v-if="total > 0" class="mobile-pagination">
        <el-pagination v-model:currentPage="currentPage" :page-size="pageSize" :total="total" layout="prev, pager, next" @current-change="handleCurrentChange"/>
      </div>

      <!-- 手机端新增表单 - 全屏弹窗 -->
      <el-dialog v-model="dialogVisible" title="新增报修" width="92%" :fullscreen="true" @close="cancel">
        <div class="mobile-form-container">
          <div class="mobile-form-section">
            <div class="mobile-form-section-title">房间信息</div>
            <div class="mobile-info-block">
              <div class="mobile-info-row">
                <span class="mobile-info-label">房间</span>
                <span class="mobile-info-value">{{ formatRoomLabel() }}</span>
              </div>
              <div class="mobile-info-row">
                <span class="mobile-info-label">申请人</span>
                <span class="mobile-info-value">{{ form.repairer || '-' }}</span>
              </div>
            </div>
          </div>
          <div class="mobile-form-section">
            <div class="mobile-form-section-title">报修信息</div>
            <el-form ref="formRef" :model="form" :rules="rules" label-position="top">
              <el-form-item label="标题" prop="title">
                <el-input v-model="form.title" clearable placeholder="请输入报修标题"/>
              </el-form-item>
              <el-form-item label="报修内容" prop="content">
                <el-input v-model="form.content" :autosize="{ minRows: 4, maxRows: 10 }" type="textarea" clearable placeholder="请描述报修问题"/>
              </el-form-item>
            </el-form>
          </div>
        </div>
        <template #footer>
          <div class="mobile-form-footer">
            <el-button @click="cancel" style="flex:1">取消</el-button>
            <el-button type="primary" @click="save" style="flex:1">提交</el-button>
          </div>
        </template>
      </el-dialog>

      <!-- 手机端详情弹窗 -->
      <el-dialog v-model="detailDialog" title="报修详情" width="92%" :fullscreen="true">
        <div class="mobile-form-container">
          <div class="mobile-form-section">
            <div class="mobile-form-section-title">基本信息</div>
            <div class="mobile-info-block">
              <div class="mobile-info-row">
                <span class="mobile-info-label">标题</span>
                <span class="mobile-info-value">{{ detail.title || '-' }}</span>
              </div>
              <div class="mobile-info-row">
                <span class="mobile-info-label">宿舍号</span>
                <span class="mobile-info-value">{{ detail.dormRoomId || '-' }}</span>
              </div>
              <div class="mobile-info-row">
                <span class="mobile-info-label">申请人</span>
                <span class="mobile-info-value">{{ detail.repairer || '-' }}</span>
              </div>
              <div class="mobile-info-row">
                <span class="mobile-info-label">状态</span>
                <el-tag size="small" :type="detail.state === '已处理' ? 'success' : 'info'">{{ detail.state }}</el-tag>
              </div>
              <div class="mobile-info-row">
                <span class="mobile-info-label">提交时间</span>
                <span class="mobile-info-value">{{ detail.orderBuildTime || '-' }}</span>
              </div>
              <div class="mobile-info-row">
                <span class="mobile-info-label">完成时间</span>
                <span class="mobile-info-value">{{ detail.orderFinishTime || '-' }}</span>
              </div>
            </div>
          </div>
          <div class="mobile-form-section">
            <div class="mobile-form-section-title">报修内容</div>
            <div class="mobile-content-block" v-html="detail.content || '-'"></div>
          </div>
        </div>
        <template #footer>
          <el-button type="primary" @click="closeDetails" style="width:100%">确定</el-button>
        </template>
      </el-dialog>
    </div>
  </div>
</template>
<script src="@/assets/js/ApplyRepairInfo.js"></script>
<style scoped>
/* === PC端样式 === */

/* === 手机端样式 === */
.mobile-container { padding: 12px; }
.mobile-top-bar { display: flex; align-items: center; gap: 8px; margin-bottom: 12px; }
.mobile-search { flex: 1; }
.mobile-list { min-height: 200px; }
.mobile-empty { text-align: center; color: #999; padding: 40px 0; font-size: 14px; }
.mobile-card { background: #fff; border-radius: 10px; padding: 14px; margin-bottom: 10px; box-shadow: 0 1px 4px rgba(0,0,0,0.06); }
.mobile-card-header { display: flex; justify-content: space-between; align-items: center; margin-bottom: 10px; }
.mobile-card-title { font-size: 15px; font-weight: 600; color: #303133; }
.mobile-card-body { }
.mobile-card-row { display: flex; justify-content: space-between; align-items: center; padding: 4px 0; }
.mobile-card-label { color: #909399; font-size: 13px; }
.mobile-card-value { color: #606266; font-size: 13px; }
.mobile-pagination { display: flex; justify-content: center; margin-top: 12px; }

/* 手机端表单 */
.mobile-form-container { }
.mobile-form-section { background: #fff; border-radius: 10px; padding: 16px; margin-bottom: 12px; }
.mobile-form-section-title { font-size: 15px; font-weight: 600; color: #303133; margin-bottom: 12px; padding-left: 10px; border-left: 3px solid #409eff; }
.mobile-info-block { }
.mobile-info-row { display: flex; justify-content: space-between; align-items: center; padding: 10px 0; border-bottom: 1px solid #f2f3f5; }
.mobile-info-row:last-child { border-bottom: none; }
.mobile-info-label { color: #909399; font-size: 14px; }
.mobile-info-value { color: #303133; font-size: 14px; font-weight: 500; }
.mobile-content-block { padding: 10px; background: #f5f7fa; border-radius: 8px; font-size: 14px; color: #303133; line-height: 1.6; }
.mobile-form-footer { display: flex; gap: 12px; }
</style>
